import { render, staticRenderFns } from "./TeamBanner.vue?vue&type=template&id=3e187bb8&scoped=true&"
import script from "./TeamBanner.vue?vue&type=script&lang=js&"
export * from "./TeamBanner.vue?vue&type=script&lang=js&"
import style0 from "./TeamBanner.vue?vue&type=style&index=0&id=3e187bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e187bb8",
  null
  
)

export default component.exports